import React from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import classnames from 'classnames';
import IconSunny from 'assets/images/icon-sunny.svg';
import IconMoon from 'assets/images/icon-moon.svg';
import styles from './styles';
import { Controller } from 'react-hook-form';
import TimeInput from 'components/TimeInput';
import WeekShift from './WeekShift/WeekShift';

const ShiftsBlock = ({ classes, pageType, errors, control, getValues, watch }) => {
  const {
    defaultDayTime = {},
    defaultNightTime = {},
    // scheduleNotifications,
  } = useSelector((state) => state.settings.locationSettings);

  const renderShiftTime = (shiftType, shiftTypeValue) => {
    if (!shiftTypeValue?.hour) return;
    return (
      <Grid item xs={12}>
        <label>
          <Typography variant="body1" color="textSecondary" className={classes.regularFontWeight}>
            Start Time:
          </Typography>
        </label>
        <Controller
          name={shiftType}
          control={control}
          render={({ value, onChange }) => (
            <TimeInput value={value} onChange={onChange} className={classes.time} />
          )}
        />
      </Grid>
    );
  };

  const renderAllowedTimeoff = () => {
    return (
      <Grid item direction={'column'}>
        <label htmlFor="allowedTimeoff">
          <Typography variant="body1" color="textSecondary" className={classes.regularFontWeight}>
            Default Paid Time Off:
          </Typography>
        </label>
        <Grid container item direction={'row'} alignItems={'center'}>
          <Controller
            name="allowedTimeoff"
            control={control}
            as={
              <TextField
                id="allowedTimeoff"
                type="number"
                className={classes.textField}
                variant="outlined"
                inputProps={{ 'aria-label': 'Default Paid Time Off' }}
              />
            }
          />
          <Typography variant="body1" className={classes.ptoHoursText}>
            hours
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderHQLocation = () => {
    return (
      <Grid container item direction={'column'} alignItems={'left'}>
        <label htmlFor="headquartersLocation">
          <Typography variant="body1" color="textSecondary" className={classes.regularFontWeight}>
            Headquarters Address:
          </Typography>
        </label>

        <Controller
          name="headquartersLocation"
          control={control}
          as={
            <TextField
              id="headquartersLocation"
              name="headquartersLocation"
              className={classes.textField}
              variant="outlined"
              inputProps={{ 'aria-label': 'Headquarter Location' }}
              fullWidth={true}
            />
          }
        />
      </Grid>
    );
  };

  return (
    <Grid item xs={12} md={12}>
      <Grid xs={12} container spacing={5}>
        <Grid item container xs={12} md={6}>
          <Typography variant="h4">General</Typography>
        </Grid>
      </Grid>
      <Grid xs={12} container spacing={5}>
        <Grid container item alignItems={'center'} xs={12} md={4}>
          {renderHQLocation()}
        </Grid>
        <Grid container item alignItems={'center'} xs={12} md={8}>
          {watch('availabilityCalendar') !== false && renderAllowedTimeoff()}
        </Grid>

        <>
          <WeekShift pageType={pageType} errors={errors} control={control} getValues={getValues} watch={watch} />
        </>
        <Grid container item alignItems={'center'} xs={12} md={12}>
          <Grid item xs={2}>
            <Typography variant="body1" color="textSecondary" className={classes.regularFontWeight}>
              Shift:
            </Typography>
            <Typography
              variant="body1"
              color="textPrimary"
              className={classnames(classes.fieldValue, classes.paddingTop)}
            >
              <img src={IconSunny} alt="sunny" className={classes.shiftImage} />
              Day
            </Typography>
          </Grid>
          <Grid container item alignItems={'center'} xs={9} md={4} lg={3}>
            {renderShiftTime('defaultDayTime', defaultDayTime)}
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={12} container spacing={5} style={{ marginBottom: 20 }}>
        <Grid container item alignItems={'center'} xs={12} md={12}>
          <Grid item xs={2}>
            <Typography variant="body1" color="textSecondary" className={classes.regularFontWeight}>
              Shift:
            </Typography>
            <Typography
              variant="body1"
              color="textPrimary"
              className={classnames(classes.fieldValue, classes.paddingTop)}
            >
              <img src={IconMoon} alt="moon" className={classes.shiftImage} />
              Night
            </Typography>
          </Grid>
          <Grid container item alignItems={'center'} xs={9} md={4} lg={3}>
            {renderShiftTime('defaultNightTime', defaultNightTime)}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

ShiftsBlock.propTypes = {
  classes: propTypes.object.isRequired,
  pageType: propTypes.string.isRequired,
  errors: propTypes.object.isRequired,
};

export default withStyles(styles)(ShiftsBlock);
